// Vendors
import styled from 'styled-components';

const LandingOptionsModalTitleComponentStyled = styled.header`
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing_250};
`;
LandingOptionsModalTitleComponentStyled.displayName = 'LandingOptionsModalTitleComponentStyled';

export { LandingOptionsModalTitleComponentStyled };
